// extracted by mini-css-extract-plugin
export default {"input":"vDGAK2y2QppDuagi6Xdg"};